import React,{useEffect,useState} from 'react';
import Calendar from 'react-calendar';
import TopTitle from './TopTitle';
import axios from 'axios';
import {formatDate,returnDate,formatDate3,currentDate,instance} from './common';
import Pagination from "react-js-pagination";
import Bottom_menu from './Bottom_menu';


function minusArrow(){
    let text = document.querySelector('.react-calendar__navigation__label__labelText').innerHTML;
    if(text){
        text = text.replace(' ','').replace('월','').replace('년','-')
        if(text.split('-')[1]*1 <= 10 && text.split('-')[1]*1 > 1){
            text = text.split('-')[0] + '-0' + ((text.split('-')[1]*1)-1);
        }else if(text.split('-')[1]*1 > 10 && text.split('-')[1]*1 < 13){
            text = text.split('-')[0] + '-' + ((text.split('-')[1]*1)-1);
        }else if(text.split('-')[1]*1 == 1){
            text = (text.split('-')[0]*1-1) + '-12';
        }
    }
    return text;
    
}

function minusArrowD(){
    let text = document.querySelector('.react-calendar__navigation__label__labelText').innerHTML;
    if(text){
        text = text.replace(' ','').replace('월','').replace('년','-')
        if(text.split('-')[1]*1 <= 10 && text.split('-')[1]*1 > 1){
            text = (text.split('-')[0]*1-1) + '-0' + ((text.split('-')[1]*1));
        }else if(text.split('-')[1]*1 > 10 && text.split('-')[1]*1 < 13){
            text = (text.split('-')[0]*1-1) + '-' + ((text.split('-')[1]*1));
        }else if(text.split('-')[1]*1 == 1){
            text = (text.split('-')[0]*1-1) + '-' + ((text.split('-')[1]*1));
        }
    }
    return text;
    
}


function plusArrow(){
    let text = document.querySelector('.react-calendar__navigation__label__labelText').innerHTML;
    if(text){
        text = text.replace(' ','').replace('월','').replace('년','-')
        if(text.split('-')[1]*1 < 9 && text.split('-')[1]*1 >= 1){
            text = text.split('-')[0] + '-0' + ((text.split('-')[1]*1)+1);
        }else if(text.split('-')[1]*1 >= 9 && text.split('-')[1]*1 < 12){
            text = text.split('-')[0] + '-' + ((text.split('-')[1]*1)+1);
        }else if(text.split('-')[1]*1 == 12){
            text = (text.split('-')[0]*1+1) + '-01';
        }
    }
    return text;
    
}

function plusArrowD(){
    let text = document.querySelector('.react-calendar__navigation__label__labelText').innerHTML;
    if(text){
        
        text = text.replace(' ','').replace('월','').replace('년','-')
        if(text.split('-')[1]*1 < 10 && text.split('-')[1]*1 >= 1){
            text = (text.split('-')[0]*1+1) + '-0' + ((text.split('-')[1]*1));
        }else if(text.split('-')[1]*1 >= 10 && text.split('-')[1]*1 < 12){
            console.log('변환 전 : ', text)
            text = (text.split('-')[0]*1+1) + '-' + ((text.split('-')[1]*1));
        }else if(text.split('-')[1]*1 == 12){
            text = (text.split('-')[0]*1+1) + '-' + ((text.split('-')[1]*1));
        }
    }
    return text;
    
}

function dayDisabled(data,date){
    let isCheck = false;
    data.forEach(v => {
        if(v.h_date === formatDate(date)) isCheck = true
    })
    return isCheck
}

function changeDate(v){
    let date = returnDate(v);
    return formatDate3(date)
}


function DrawHoli({detect,data,setData,show_date}){

    const ppp = 10;
    const [page, setPage] = useState(1);
    const [total, setTotal] = useState(0);

    const parsedsigong = JSON.parse(window.sessionStorage.result);
    const si_id = parsedsigong.u_sigong;

    let obj = {
        page: page,
        ppp: ppp,
        h_si_id: si_id,
        show_date:show_date
    }

    useEffect(() => {

        const fetchData = async () => {
            instance.post('/holiday/all', obj).then(function (res) {
                setData(res.data.rows);
                setTotal(res.data.totalCount);
            });

        };
        fetchData();
    }, [page, ppp,detect, total, show_date]);

    const style = {
        position:'absolute',
        right:'10px',
        color:'lightgray'
    }

    const delHoli = (e) => {
        if(window.confirm('정말 삭제하시겠습니까?')){
            const {id} = e.target.dataset;
        
            const fetchData = async () => {
                instance.post('/holiday/delete', {h_id:id}).then(function (res) {
                    alert('삭제 되었습니다.');
                    setData(data.filter(v => v.h_id !== id));
                    setTotal(total-1);
                });
    
            };
            fetchData();
        }

    }


    return (
        <div className="container mt-5 text-center">
            <table className="table table-bordered">
                <thead>
                    <tr>
                        <th>No</th>
                        <th>날짜</th>
                    </tr>
                   
                </thead>
                <tbody>
                    {
                        data.map((v,i) => 
                            <tr key={v.h_id}>
                                <td>{i+1}</td>
                                <td style={{position:'relative'}}>{changeDate(v.h_date)} <span style={style} onClick={delHoli} data-id={v.h_id}>삭제</span></td>
                            </tr>
                        )
                    }
                </tbody>
                <tfoot></tfoot>
            </table>
            <Pagination
                activePage={page}
                itemsCountPerPage={10}
                totalItemsCount={total}
                pageRangeDisplayed={10}
                onChange={(pageNumber) => setPage(pageNumber)}
            />
        </div>
    )
}
function Holiday(){
    console.log('Holiday 렌더링')
    const parsedsigong = JSON.parse(window.sessionStorage.result);
    const si_id = parsedsigong.u_sigong;

    const [data, setData] = useState([]);
    const [value, onChange] = useState(new Date());
    const [detect, setDetect] = useState(0);
    const [show_date, setDate] = useState(formatDate(value).slice(0,7));
    const chagneDate = (value) => {
        onChange(value)
    }



    const tileDisabled = ({activeStartDate, date, view }) => dayDisabled(data,date) === true;

    const onClickYear = (value) => {
        setDate(formatDate(value).slice(0,7))
    }

    const onClickMonth = (value) => {
        setDate(formatDate(value).slice(0,7))
    }

 

    const insert = () => {
        
        console.log('온클릭 발생')
        let obj = {
            h_si_id:si_id,
            h_date:formatDate(value)
        }
        
        const fetchData = async () => {
            instance.post('/holiday/insert', {obj:obj}).then(function (res) {
                
                alert(res.data.msg);
                setDetect(detect+1);
            });

        };
        fetchData();
    }


    useEffect(() => {
        let prev = document.querySelector('.react-calendar__navigation__prev-button');
        prev.addEventListener("click", () => setDate(minusArrow), false);

        let next = document.querySelector('.react-calendar__navigation__next-button');
        next.addEventListener("click", () => setDate(plusArrow), false);

        let prevD = document.querySelector('.react-calendar__navigation__prev2-button');
        prevD.addEventListener("click", () => setDate(minusArrowD), false);

        let nextD = document.querySelector('.react-calendar__navigation__next2-button');
        nextD.addEventListener("click", () => setDate(plusArrowD), false);
        
    }, []);

    console.log('show_date : ', show_date)

    return (
        <>
            <TopTitle title='휴무일 설정' />
            <Calendar 
            className="mb-5 c_mgauto" 
            onChange={chagneDate}  
            value={value}
            tileDisabled={tileDisabled}
            onClickYear={onClickYear}
            onClickMonth={onClickMonth}
            />
            <div className="container" onClick={insert}>
                <span className="pt-3 pb-3 btn btn-primary btn-block">휴무일 추가</span>
            </div>
            <DrawHoli detect={detect} data={data} setData={setData} show_date={show_date}/>
            <Bottom_menu />
        </>
    )
}

export default Holiday